import {useEffect, useState} from 'react';
import TextField from "../../fragments/form/TextField"
import CheckboxSelector from "../../fragments/form/CheckboxSelector"
import SubmitButton from "../../fragments/form/SubmitButton"


const EditMunicipalityForm = (props) => {
    const [formData, setFormData] = useState(new FormData());

    const onChange = (id, value) => {
        formData.set(id, value);
        setFormData(formData);
    }

    const onSubmit = (e) => {
        e.preventDefault();
        props.onSubmit(formData);
    }
   
    return (
        <form onSubmit={onSubmit}>
            <TextField id="city" required={true} value={props.municipality.city} onChange={onChange} label="Name" />
            <CheckboxSelector id="is_published" value={props.municipality.is_published} onChange={onChange} label="Publish" />
            <SubmitButton />
        </form>
    );
}

export default EditMunicipalityForm;
